import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

type BrandLogoVariant = 'wordmark' | 'emblem';
type BrandLogoSize = 'sm' | 'md' | 'lg' | 'hero';

const sizeClass: Record<BrandLogoSize, string> = {
  sm: 'brand-logo--sm',
  md: 'brand-logo--md',
  lg: 'brand-logo--lg',
  hero: 'brand-logo--hero',
};

const emblemSrc = `${import.meta.env.BASE_URL}brand/soroush-emblem.png?v=21`;

export interface BrandLogoProps {
  variant?: BrandLogoVariant;
  size?: BrandLogoSize;
  to?: string | null;
  className?: string;
  priority?: boolean;
}

function Emblem({ priority = false }: { priority?: boolean }) {
  return (
    <img
      className="brand-logo__emblem"
      src={emblemSrc}
      alt=""
      width={520}
      height={360}
      decoding="async"
      fetchPriority={priority ? 'high' : 'auto'}
    />
  );
}

export function BrandLogo({
  variant = 'wordmark',
  size = 'md',
  to = '/',
  className = '',
  priority = false,
}: BrandLogoProps) {
  const { t } = useTranslation();
  const label = t('common.brand');

  const content =
    variant === 'emblem' ? (
      <Emblem priority={priority} />
    ) : (
      <span className="brand-logo__lockup">
        <Emblem priority={priority} />
        <span className="brand-logo__text">{label}</span>
      </span>
    );

  const classes = `brand-logo ${sizeClass[size]} brand-logo--${variant} ${className}`.trim();

  if (to === null) {
    return (
      <span className={classes} aria-label={label}>
        {content}
      </span>
    );
  }

  return (
    <Link to={to} className={classes} aria-label={label}>
      {content}
    </Link>
  );
}
